module.exports = __webpack_public_path__ + "img/cover3.a850bacc.webp";